export const AVG_MEDIA_LENGTH_LABEL = 'Media length in minutes'
export const MBOX_LOW_LABEL = 'M-Box low'
export const MBOX_STANDARD_LABEL = 'M-Box standard'
export const MBOX_HIGH_LABEL = 'M-Box high'
export const MBOX_CUSTOM_LABEL = 'M-Box custom'

export const S3_DOWNLOADS_LABEL = 'S3 downloads'

export const MASTER_DELIVERY_LABEL = 'Master delivery'

export const STORAGE_LABEL = 'Storage'
export const STORAGE_HIGH_VELOCITY_LABEL = 'High velocity'
export const STORAGE_HIGH_DENSITY_LABEL = 'High density'
export const STORAGE_AWS_GLACIER_LABEL = 'AWS Glacier'
export const STORAGE_AWS_DEEP_GLACIER_LABEL = 'AWS Deep Glacier'

export const QUICKLINK_VIEWS_LABEL = 'Quicklink views'
export const QUICKLINK_DOWNLOADS_LABEL = 'Quicklink downloads'
export const MOBILE_UPLOADS_LABEL = 'Mobile uploads'

export const MASTER_DELIVERY_TIER1_LABEL = '0 to 1 min'
export const MASTER_DELIVERY_TIER2_LABEL = '1 to 5 min'
export const MASTER_DELIVERY_TIER3_LABEL = '5 to 30 min'
export const MASTER_DELIVERY_TIER4_LABEL = '30 to 60 min'
export const MASTER_DELIVERY_TIER5_LABEL = '60 to 90 min'
export const MASTER_DELIVERY_TIER6_LABEL = '90 to 120 min'
